<template>
  <div>
    <fb-text-v1
      class="mb-0"
      v-if="showType == 'form-builder'"
      showType="form-builder"
      :properties="properties"
      :id="id"
    ></fb-text-v1>
    <div v-if="showType == 'properties'">
      <form-header-v1-properties :formId="formId" />
    </div>
    <fb-text-v1
      v-if="showType == 'form-viewer' || showType == 'e-form'"
      :showType="showType"
      :properties="properties"
      :id="id"
      :form="form"
    ></fb-text-v1>
  </div>
</template>

<script>
import FormHeaderV1Properties from "./FormHeaderV1Properties.vue";
export default {
  name: "FormHeaderV1",
  components: { FormHeaderV1Properties },
  props: ["showType", "properties", "form", "id", "formId"],
  methods: {
    getBakedLayout() {
      return ``;
    }
  }
};
</script>
